import { Dispatch } from '@reduxjs/toolkit';
import { GraphQLUserAliasId } from '../../../../utils/types';
import { IAlias } from '../../../AliasEditor';
import {
  resetAliasReplacementAction,
  updateAliasReplacementAction,
} from '../../../../redux/slices/analyses';

export const createAlias = (
  analysisId: string,
  userAliasId: GraphQLUserAliasId,
  name: string,
  dispatch: Dispatch,
): IAlias => {
  return {
    type: 'alias',
    analysisId,
    name,
    userAliasId,
    apply: (newAlias: string) => {
      dispatch(
        updateAliasReplacementAction({
          analysisId,
          aliasId: userAliasId,
          replacement: newAlias,
        }),
      );
    },
    reset: () => {
      dispatch(
        resetAliasReplacementAction({ analysisId, aliasId: userAliasId }),
      );
    },
  };
};
